<div class="modal-header">
  <h4 class="modal-title">{{ dataConnection?.name }}</h4>
  <button
    type="button"
    class="btn-close"
    (click)="modalRef.close()"
    aria-label="Close"
  ></button>
</div>
<div class="modal-body">
  <p>{{ dataConnection?.description }}</p>
  <label class="mt-2">{{ 'dataconnection.url' | translate }}</label>
  <p>{{ getUrl() }}</p>
  <app-error [error]="error"></app-error>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-outline-primary"
    (click)="modalRef.close()"
  >
    {{ 'close' | translate }}
  </button>
  @if (workflow) {
    <button
      type="button"
      class="btn btn-primary"
      (click)="execute()"
      [ladda]="loading"
    >
      {{ 'dataconnection.execute' | translate }}
    </button>
  }
</div>
